import { checkIfCompatibleWithBackend, } from "@todesktop/client-util";
import { invoke, construct } from "./invoke.js";
/**
 * Creates a new FindInPageView
 *
 * @param ref - ref: Reference for the FindInPageView
 * @param opriona - options: Options for
 * @public
 */
export async function create(browserWindowRef, options) {
    if (checkIfCompatibleWithBackend("findInPageView:create", "6.8.0")) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return construct({
            namespace: "FindInPageView",
            args: [browserWindowRef, options],
        });
    }
    return null;
}
/**
 * Opens the FindInPageView in the attached window.
 *
 * @param ref - ref: Reference for the FindInPageView
 * @public
 */
export async function open(viewRef) {
    if (checkIfCompatibleWithBackend("findInPageView:open", "6.8.0")) {
        return invoke({
            instanceRef: viewRef,
            namespace: "FindInPageView",
            method: "open",
            args: [],
        });
    }
}
/**
 * Closes the FindInPageView in the attached window.
 *
 * @param ref - ref: Reference for the FindInPageView
 * @public
 */
export async function close(viewRef) {
    if (checkIfCompatibleWithBackend("findInPageView:open", "6.8.0")) {
        return invoke({
            instanceRef: viewRef,
            namespace: "FindInPageView",
            method: "close",
            args: [],
        });
    }
}
